const hosts = {
  'development':{
    'hostName':'https://test1-sc.yunqueyi.com',
    'emr':'https://test1-emr.yunqueyi.com/api'
  },
  'test':{
    'hostName':'https://test1-sc.yunqueyi.com',
    'emr':'https://test1-emr.yunqueyi.com/api'
  },
  'uat':{
    'hostName':'https://uat-sc.yunqueyi.com',
    'emr':'https://test1-emr.yunqueyi.com/api',// 外包接口没有uat，因此用test1
  },
  'production':{
    'hostName':'https://sc.yunqueyi.com',
    'emr':'https://his.yunqueyi.com/api'
  },

}

export default hosts



// WEBPACK FOOTER //
// ./src/apis/hostConfig.js